import React from "react";
import SidebarNavListItem from "./SidebarNavListItem"; // adjust the path if needed
import { ArrowLeftCircle } from "react-feather"; // feather icons, optional

const SidebarFooter = () => {
  return (
    <div className="sidebar-cta">
      <ul className="sidebar-nav">
        <SidebarNavListItem
          title="Home"
          href="/"
          icon={ArrowLeftCircle} // optional icon from feather
        />
      </ul>
    </div>
  );
};

export default SidebarFooter;
